module.exports = __webpack_public_path__ + "static/media/17CO247.1ae04fb0.jpg";